import { createFileRoute, redirect } from "@tanstack/react-router";
import { SubPartnersTableEnhanced } from "@/app/partner/pages/subpartners/SubPartnersTableEnhanced";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/subpartners/")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "subpartners");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: SubPartnersTableEnhanced,
});
